export const ACCOUNT_SETTINGS_FORM = 'ACCOUNT_SETTINGS_FORM';
export const ACCOUNT_SETTINGS_FEEDBACK = 'ACCOUNT_SETTINGS_FEEDBACK';

export const IDENTITY_VERIFICATION_FORM = 'IDENTITY_VERIFICATION_FORM';

export const ADDITIONAL_IDENTITY_VERIFICATION_FORM = 'ADDITIONAL_IDENTITY_VERIFICATION_FORM';

export const DOCUMENT_PASSPORT = 'PASSPORT';
export const DOCUMENT_ID_CARD = 'ID_CARD';
export const DOCUMENT_DRIVERS = 'DRIVERS';
export const DOCUMENT_UTILITY_BILL = 'UTILITY_BILL';
export const DOCUMENT_BANK_STATEMENT = 'DOCUMENT_BANK_STATEMENT';
export const DOCUMENT_OTHER = 'OTHER';

export const DOCUMENT_FRONT_SIDE = 'FRONT_SIDE';
export const DOCUMENT_BACK_SIDE = 'BACK_SIDE';

export const DOCUMENT_TYPES = [
  {
    value: DOCUMENT_ID_CARD,
    label: 'Government Issued Photo ID',
    translateKey: 'profile:verification.documentTypes.ID_CARD',
  },
  {
    value: DOCUMENT_PASSPORT,
    label: 'Passport',
    translateKey: 'profile:verification.documentTypes.PASSPORT',
  },
];

export const DOCUMENT_TYPES_ADDITIONAL_IDENTITY = [
  {
    value: DOCUMENT_UTILITY_BILL,
    label: 'Utility Bill',
    translateKey: 'profile:verification.documentTypes.UTILITY_BILL',
  },
  {
    value: DOCUMENT_BANK_STATEMENT,
    label: 'Bank Statement',
    translateKey: 'profile:verification.documentTypes.DOCUMENT_BANK_STATEMENT',
  },
  {
    value: DOCUMENT_OTHER,
    label: 'Other',
    translateKey: 'profile:verification.documentTypes.OTHER',
  },
];

export const DOCUMENT_SIDES = [
  { value: DOCUMENT_FRONT_SIDE, label: 'Front' },
  { value: DOCUMENT_BACK_SIDE, label: 'Back' },
];

export const REQUIRE_BACKSIDE = new Set([DOCUMENT_DRIVERS, DOCUMENT_ID_CARD]);

export const UPLOAD_BACKSIDE_MODAL = 'UPLOAD_BACKSIDE_MODAL';

export const STEPPER_KEYS = {
  PERSONAL: 0,
  EXPERIENCE: 1,
  ACCOUNT: 2,
  DOCUMENTS: 3,
};

export const TIN_COUNTRIES = {
  AUSTRIA: 'Austria',
  BELGIUM: 'Belgium',
  BULGARY: 'Bulgary',
  CYPRUS: 'Cyprus',
  CZECH_REPUBLIC: 'Czech Republic',
  GERMANY: 'Germany',
  DENMARK: 'Denmark',
  ESTONIA: 'Estonia',
  GREECE: 'Greece',
  SPAIN: 'Spain',
  FINLAND: 'Finland',
  FRANCE: 'France',
  CROATIA: 'Croatia',
  HUNGARY: 'Hungary',
  IRELAND: 'Ireland',
  ITALY: 'Italy',
  LITHOUANIA: 'Lithouania',
  LUXEMBURG: 'Luxemburg',
  LATVIA: 'Latvia',
  MALTA: 'Malta',
  NETHERLANDS: 'Netherlands',
  POLAND: 'Poland',
  PORTUGAL: 'Portugal',
  ROMANIA: 'Romania',
  SWEDEN: 'Sweden',
  SLOVENIA: 'Slovenia',
  SLOVAKIA: 'Slovakia',
};
